export const MapIconsNameContent = {
  permanent: '\\e94c',
  preorder: '\\e941',
  has_promotion: '\\e933',
  is_new: '\\e931',
  favoris: '\\e925',
  assortiment: '\\e945',
  save: '\\e93d',
};
